export default {
	"portal.paymentMethodEmilEmbed.title": "Portal: Zahlungsart ändern",
	"portal.paymentMethodEmilEmbed.submit": "Zahlungsart ändern",
	"portal.paymentMethodEmilEmbed.save": "Speichern",
} as const;
